import { useCallback, useMemo } from 'react';
import { toast } from 'sonner';
import api, { formatApiError } from '../../lib/api';

export function useFinanceActions({ refresh }) {
  const cashAction = useCallback(async (entryId, action) => {
    try {
      await api.post(`/admin/finance/cash/${entryId}/${action}`);
      toast.success(action === 'handover' ? 'Cash handover recorded' : action === 'reconcile' ? 'Cash reconciled — order confirmed' : 'Discrepancy flagged');
      await refresh(false);
    } catch (e) { toast.error(formatApiError(e)); }
  }, [refresh]);

  const payoutAction = useCallback(async (payoutId, action, meta) => {
    try {
      if (action === 'generate') {
        const res = await api.post('/admin/payouts/generate');
        toast.success(res.data.length ? `${res.data.length} payout(s) generated` : 'Nothing ready to pay out');
      } else if (action === 'paid') {
        await api.post(`/admin/payouts/${payoutId}/mark-paid`, meta || {});
        toast.success('Payout marked as paid');
      } else {
        await api.post(`/admin/payouts/${payoutId}/status`, { action });
        toast.success('Payout status updated');
      }
      await refresh(false);
    } catch (e) { toast.error(formatApiError(e)); }
  }, [refresh]);

  const updateDeliverySettings = useCallback(async (settings) => {
    try {
      await api.put('/admin/settings/deliverySettings', { value: settings });
      toast.success('Delivery settings saved', { description: 'New fees apply at checkout immediately.' });
      await refresh(true);
    } catch (e) { toast.error(formatApiError(e)); }
  }, [refresh]);

  return useMemo(() => ({ cashAction, payoutAction, updateDeliverySettings }), [cashAction, payoutAction, updateDeliverySettings]);
}
